<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div :key="keyValue" class="read-only-offer-basic-section scope-offer">
		<egranty-section-divider
			text="Zakres oferty"
			icon="place"
			aria-label="label for icon"
			:show-print-info="showPrintInfo"
		></egranty-section-divider>
		<br>
		<v-flex xs12 sm6 d-flex>
			<v-autocomplete
				class="ml-3"
				:disabled="readonly"
				v-model="mainCountryName"
				:items="countries"
				item-text="name"
				item-value="name"
				label="Główny kraj"
				aria-label="main country"
				for="priority-tree-select-main-country"
				id="priority-tree-select-main-country"
				@input="updateTree"
			></v-autocomplete>
		</v-flex>
		<div v-if="treeLoaded===false && mainCountryName">
			<offer-button
				v-if="!readonly"
				text="Edytuj wybór priorytetów"
				icon="edit"
				@click="startEdit(mainCountryName)"
			></offer-button>
		</div>
		<v-treeview
			class="ma-3 ml-4 priority-tree-tree-view"
			v-if="treeLoaded===true"
			:key="keyValue"
			v-model="tree"
			:active.sync="active"
			:items="tasks"
			:open-all="true"
			selectable
			:open.sync="open"
			item-key="uniqueName"
			:return-object=true
			aria-label="label for text"
		>
			<template v-slot:prepend="{ item }" >
				<v-icon>  label</v-icon>
			</template>
		</v-treeview>
		<br>
		<v-card
			class="priority-card mt-3"
			v-for="(optionsList, indexList) in priorityOptions"
			v-bind:key="indexList"
			elevation="1"
			aria-label="label for priority"
		>
			<div class="ml-3 mr-3"
				v-if="optionsList !== undefined"
			>
				<h2>Priorytet: {{optionsList.name}}</h2>
				<v-select
					:disabled="readonly"
					:key="keyValue"
					v-if="data.selected[indexList] !== undefined && optionsList.options.length !== 0"
					v-model="data.selected[indexList].areas"
					:items="optionsList.options"
					multiple
					item-text="name"
					item-value="id"
					aria-label="areas"
					label="Cele ogólne / rezultaty, których dotyczy oferta"
					for="priority-tree-areas"
				></v-select>
			</div>
		</v-card>
		<v-flex xs12 sm6 d-flex>
			<v-autocomplete class="ml-3 mt-4"
				v-if="manyAccreditationCountries && data.mainCountryId && extraCountries.length > 0"
				:disabled="readonly"
				v-model="data.extraCountries"
				:items="extraCountries"
				multiple
				item-text="name"
				item-value="id"
				label="Dodatkowe kraje"
				aria-label="extra countries"
				for="priority-tree-extra-countries"
				@input="extraCountriesChanged"
			></v-autocomplete>
		</v-flex>

		<egranty-validation-error
			:error="error"
		></egranty-validation-error>
	</div>

</template>

<script>
	import {Task} from "@/api/generated/Task";
	import {TaskAccreditationCountry} from "@/api/generated/TaskAccreditationCountry";
	import OfferButton from "./OfferButton";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";

	export default {
		name: "PriorityTree",
		components: {EgrantyValidationError, EgrantySectionDivider, OfferButton},

		computed: {},
		methods: {

			validate() {
				if (this.data.mainCountryId === '' || this.data.mainCountryId === null) {
					this.error = "Proszę wybrać kraj, na który składana jest oferta";
					return false;
				}
				if (this.data.selected.length === 0) {
					this.error = "Proszę wybrać co najmniej jeden priorytet, którego dotyczy oferta";
					return false;
				}
				if (!this.manyPriorities && this.data.selected.length > 1) {
					this.error = "Proszę wybrać nie więcej niż jeden priorytet";
					return false;
				}

				if (!this.manyTasks) {
					let task = "";
					for (var treeItem in this.tree) {
						if (treeItem.type === 'priority') {
							if (task === '') {
								task = treeItem.taskName;
							}
							if (task !== treeItem.taskName) {
								this.error = "Proszę wybrać nie więcej niż jedno zadanie";
								return false;
							}
						}
					}
				}

				if (!this.manyAreas) {
					let totalAreasCount = 0;
					for (let priority of this.data.selected) {
						totalAreasCount += priority.areas.length;
					}
					if (totalAreasCount > 1) {
						this.error = "Proszę wybrać nie więcej niż jeden obszar";
						return false;
					}
				}

				return true;
			},

			startEdit() {
				this.error = "";
				this.data.selected = [];
				this.priorityOptions = [];
				this.tasks = this.tasksForPriorities.sort(function(a, b) {
          return a.orderId - b.orderId;
        });
				this.keyValue++;
				this.treeLoaded = true;
			},

			updateTree(val) {
				this.error = "";
				this.treeLoaded = true;
				this.data.mainCountryId = this.countries.find(x => x.name === val).id;
				this.loadTasks(val, true);
				this.updateExtraCountries(val);
				this.$emit("countriesChanged");
				this.$emit("input", this.data);
			},

			updateExtraCountries(val) {
				this.data.extraCountries = [];
				this.extraCountries = this.countries.filter(x => x.name !== val);
			},

			loadAreas(priority) {
				Task.getAreas(this, priority.id, response => {
						this.$set(priority, "areas", response);
						for (let e = 0; e < response.length; e++) {
							let area = response[e];
							this.$set(area, "type", "area");
							this.$set(area, "uniqueName", area.id + area.type);
						}
					},
				);
			},

			loadPriorities(task, country) {
				Task.getPriorities(this,
          country.id,
					(response) => {

						if (task.children === undefined) {
							this.$set(task, "children", []);
						}
						task.children = task.children.concat(response);
						for (let w = 0; w < response.length; w++) {
							let priority = response[w];
							this.$set(priority, "taskName", task.name);
							this.$set(priority, "countryName", country.name);
							this.$set(priority, "type", "priority");
							this.$set(priority, "uniqueName", priority.id + priority.type);
							this.loadAreas(priority);
						}
						this.left--;
						if (this.left === 0) {
							this.keyValue++;
							this.updatePriorityOptions();
						}
					});
			},

			loadCountries(task, requiredCountry) {
				Task.getTaskAccreditationCountries(this, task.id, (response) => {
					response = response.filter(country => country.name === requiredCountry);
					this.left += response.length;
					for (let q = 0; q < response.length; q++) {
						let country = response[q];

						this.$set(country, "type", "country");
						this.$set(country, "taskName", task.name);
						this.$set(country, "uniqueName", country.id + country.type);
						this.loadPriorities(task, country);
					}
					this.left--;
					if (this.left === 0) {
						this.keyValue++;
						this.updatePriorityOptions();
					}
				});
			},

			extraCountriesChanged() {
				this.$emit("countriesChanged");
				this.$emit("input", this.data);
			},

			loadTasks(requiredCountry, loadForTree) {
				if (this.contestId === undefined || this.data.mainCountryId === null) {
					return;
				}

				this.left++;
				Task.getCountryTasks(this, this.contestId, this.data.mainCountryId, (response) => {

					this.left += response.length;
					for (let i = 0; i < response.length; i++) {
						let task = response[i];
						this.$set(task, "type", "task");
						this.$set(task, "uniqueName", task.id + task.type);
						this.loadCountries(task, requiredCountry);
					}

					this.tasksForPriorities = response;
					if (loadForTree === true) {
						this.tasks = response.sort(function(a, b) {
              return a.orderId - b.orderId;
            });
					}

					this.left--;
					if (this.left === 0) {
						this.keyValue++;
						this.updatePriorityOptions();
					}

				});
			},

			updatePriorityOptions() {
				this.priorityOptions = [];
				this.priorityOptions.length = this.selected.length;
				for (let i = 0; i < this.tasksForPriorities.length; i++) {
					if (this.tasksForPriorities[i].children === undefined) {
						continue;
					}
					for (let q = 0; q < this.tasksForPriorities[i].children.length; q++) {
						let val = this.tasksForPriorities[i].children[q];
						if (this.selected.find(x => x.id === val.id)) {
							let index = this.selected.findIndex(x => x.id === val.id);
							Task.getAreas(this, val.id, response => {
									this.$set(this.priorityOptions, index, {
										name: val.name,
										id: val.id,
										options: response,
									});
									this.keyValue++;
								});
						}
					}
				}
			},

			refresh() {
				if (this.contestId === undefined) {
					return;
				}

				TaskAccreditationCountry.getAvailableCountries(
					this,
					this.contestId,
					response => {
						this.countries = response;
						this.extraCountries = response;
						this.setMainCountryName();
						this.loadTasks(this.mainCountryName, false);
					},
				);


			},

			setMainCountryName() {
				if (this.data.mainCountryId !== null) {
					let country = this.countries.find(x => x.id === this.data.mainCountryId);
					this.mainCountryName = country !== undefined ? country.name : undefined;
					this.extraCountries = this.countries.filter(x => x.name !== this.mainCountryName);
				}
			},
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					this.active = val.selected;
					this.data = val;
					this.selected = val.selected;
					this.setMainCountryName();
					this.loadTasks(this.mainCountryName, false);
					this.dataFromServerLoaded = true;
				},
			},

			tree: {
				handler(val) {
					this.error = "";
					this.data.selected = this.data.selected.filter(x => val.find(y => y.type === 'priority' && y.id === x.id));
					this.priorityOptions = [];
					for (let i = 0; i < val.length; i++) {
						if (val[i].type !== "priority") {
							continue;
						}
						if (!this.data.selected.find(x => x.id === val[i].id)) {
							this.data.selected.push({id: val[i].id, areas: []});
						}
						this.priorityOptions.push({name: val[i].name, id: val[i].id, options: val[i].areas});

					}
					//this.updatePriorityOptions();
					this.$emit("input", this.data);
				},
			},
		},


		data() {
			return {
				error: "",
				dataFromServerLoaded: false,
				treeLoaded: false,
				tree: [],
				activeTree: [],
				tasks: [],
				tasksForPriorities: [],
				selected: [],
				open: [],
				keyValue: 0,
				active: [],
				left: 0,
				countries: [],
				extraCountries: [],
				data: {
					mainCountryId: null,
					selected: [],
					extraCountries: [],
				},
				priorityOptions: [],
				mainCountryName: "",
			};
		},
		mounted() {
			this.refresh();
		},

		props: {
			value: {
				type: Object,

			},
			readonly: {type: Boolean, default: false},
			manyAccreditationCountries: {type: Boolean, default: false},
			manyTasks: {},
			manyPriorities: {},
			manyAreas: {},
			contestId: null,
			showPrintInfo: {
				type: Boolean, default: false
			}
		},
	};

</script>

<style>

	.priority-tree-tree-view .v-treeview-node__label {
		word-wrap: break-word;
		width: 100%;
	}

	.priority-tree-tree-view .v-treeview-node__content {
		max-width: 90%;
	}

	.priority-tree-tree-view .v-icon {
		display: block;
	}
</style>
